import {
	GET_LEAVE_REQUESTS,
	CLEAR_LEAVE_REQUESTS,
	GET_LEAVE_REQUEST
} from 'actions/leaveRequests';

const INITIAL_STATE = {
	leaveRequests: null,
	current: null,
	loading: false,
	error: null,
};

export default function (state = INITIAL_STATE, action) {
	switch (action.type) {
		case GET_LEAVE_REQUESTS:
			return {
				...state,
				leaveRequests: action.payload,
				loading: false,
				error: null,
			};

		case GET_LEAVE_REQUEST:
			return {
				...state,
				current: action.payload,
				loading: false,
				error: null,
			};

		case CLEAR_LEAVE_REQUESTS:
			return {
				...state,
				leaveRequests: null,
				loading: false,
				error: null,
			};

		default:
			return state;
	}
}
